module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeout-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "timeout-content"
  }, [_c('div', {
    staticClass: "timeout-pic"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeout-warning"
  }, [_c('p', [_vm._v("登录超时，"), _c('span', [_vm._v(_vm._s(_vm.num))]), _vm._v("秒后自动转入登录")]), _vm._v(" "), _c('p', [_vm._v("由于您长时间未在系统操作，为了您帐号的安全，需要重新登录。")])]), _vm._v(" "), _c('div', {
    staticClass: "timeout-btn"
  }, [_c('button', {
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("重新登录")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeout-header"
  }, [_c('div', {
    staticClass: "timeout-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeout-title"
  }, [_vm._v("六六脑"), _c('sup', [_vm._v("®")]), _vm._v("  科学健脑")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2959ff45!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/timeoutPage.vue
// module id = 968
// module chunks = 2